import { Directive, ElementRef, EventEmitter, HostBinding, inject, input, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[cslInput]',
  standalone: true,
})
export class InputDirective implements OnInit {
  private readonly elementRef: ElementRef<HTMLInputElement> = inject(ElementRef);

  forceDisabled = input<boolean>(false);
  inverted = input<boolean>(false);

  @Output() init = new EventEmitter<void>();

  @HostBinding('class') get styles(): string {
    const group = `
      group-[.g-control-invalid]:shadow-[inset_0_0_0_1px_var(--input-invalid-border-color)]
    `;
    const base = `
      w-full
      rounded-[--input-border-radius]
      border-0
      px-4
      py-3
      text-base
      font-normal
      leading-normal
    `;
    const addStyles = `
      text-[--input-text-color]
      shadow-[inset_0_0_0_1px_var(--input-border-color)]
      focus:shadow-[inset_0_0_0_1px_var(--input-active-border-color)]
      placeholder:text-[--input-placeholder-color]
      outline outline-0
      focus-visible:outline-2
      focus-visible:outline-offset-2
      ${this.inverted() ? 'focus-visible:outline-white' : 'focus-visible:outline-focus'}
    `;
    const disabledStyles = `
      bg-[--input-disabled-bg-color]
      shadow-[inset_0_0_0_1px_var(--input-disabled-border-color)]
      text-[--input-disabled-text-color]
    `;

    const additionalStyles =
      this.elementRef.nativeElement.disabled || this.forceDisabled() ? disabledStyles : addStyles;

    return `${group} ${base} ${additionalStyles}`;
  }

  ngOnInit(): void {
    this.init.emit();
  }
}
